import { memo } from 'react'
import { isEqual } from 'lodash'
import { PageTitle } from 'app/components/common/PageTitle'
import R from 'app/assets/R'
import { useTranslation } from 'react-i18next'
import Report001Container from 'app/containers/Report/Report001'

const Report001PageCpn = () => {
  const { t } = useTranslation()
  return (
    <>
      <PageTitle>{t(R.strings.report_001)}</PageTitle>
      <Report001Container />
    </>
  )
}
const Report001Page = memo(Report001PageCpn, isEqual)

export default Report001Page
